export const isIntelligenceLabEnabled = (environmentValue) =>
  String(environmentValue || "")
    .trim()
    .toLowerCase() !== "false";
